import src from "IMAGE";
export default { src, width: 590, height: 462, blurWidth: 0, blurHeight: 0};
